import * as firebase from 'firebase'

// PA Shadowing Hours Module
const state = {
  paShadowingHours: [],
};

const mutations = {
    // Set PA Shadowing Hours when user login
    setPaShadowingHours(state, payload) {
      state.paShadowingHours = payload
    },
    // Add PA Shadowing Info
    addPaInfo(state, payload) {
      state.paShadowingHours.push(payload)
    },
    // Remove PA Shadowing Info
    removePaShadowing (state, payload) {
      state.paShadowingHours.forEach(paShadow => {
        if(paShadow.id === payload) {
          state.paShadowingHours.splice(state.paShadowingHours.indexOf(paShadow), 1)
        }
      })
    },

    // Log PA Shadowing Hours
    logPaShadowingHours (state, payload) {
      for(var i=0; i < state.paShadowingHours.length; i++) {
        if(state.paShadowingHours[i].id === payload.shadowing_id) {
          state.paShadowingHours[i].logged_hours.push(payload)
        }
      }
    },

    // Remove PA Shadowing Hours
    removePaShadowingHours(state, payload) {
      for(var i=0; i < state.paShadowingHours.length; i++) {
        if(state.paShadowingHours[i].id === payload.shadowingId) {

          for(var c=0; c < state.paShadowingHours[i].logged_hours.length; c++) {
            if(state.paShadowingHours[i].logged_hours[c].id === payload.loggedHourId) {
              var index = state.paShadowingHours[i].logged_hours.indexOf(state.paShadowingHours[i].logged_hours[c])
              state.paShadowingHours[i].logged_hours.splice(index, 1)
            }
          }
        }
      }
    },

    setLogoutUser(state, payload = null) {
      state.paShadowingHours = []

    },

};

const actions = {
      // Add PA Info for Shadowing Hours
      setAddPaInfo({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/pa_shadowing/').push(payload)
          .then((data) => {
            const key = data.key
            commit('addPaInfo', {
              ...payload,
              id:key,
              logged_hours : []
            })
          })
      },
      // Edit PA Shadowing Info
      setEditPaShadow({commit, getters},payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/pa_shadowing/').child(payload.paShadowId).update(payload)
        .then((data) => {
          commit('removePaShadowing', payload)
        })
      },
      // Remove User PA Shadowing
      setRemovePaShadowing({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/pa_shadowing/').child(payload).remove()
        .then((data) => {
          commit('removePaShadowing', payload)
        })
      },

      // Log PA Shadowing Hours
      setLogPaShadowingHours({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/pa_shadowing/').child(payload.shadowing_id).child('logged_hours').push(payload)
        .then((data) => {
          const key = data.key
          commit('logPaShadowingHours', {
            ...payload,
            id:key
          })
        })
      },
      // Edit Logged PA Shadowing Hours
      setEditPaShadowingHours({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/pa_shadowing/' + payload.shadowingId + '/logged_hours/').child(payload.loggedHourId).update(payload)
        .then((data) => {
          // commit('removePaShadowing', payload)
        })
      },
      // Set Remove PA Shadowing Hours
      setRemovePaShadowingHours({commit, getters}, payload) {
        firebase.database().ref('/users/' + getters.user.uid + '/pa_shadowing/' + payload.shadowingId + '/logged_hours/').child(payload.loggedHourId).remove()
        .then((data) => {
          commit('removePaShadowingHours', payload)
        })
      },
};

const getters = {
  // PA Shadow Info
  paShadowInfo(state) {
    return (id) => {
      return state.paShadowingHours.find((paShadow) => {
        return paShadow.id === id
      })
    }
  },
  // PA shadowing Hours
    paShadowingHours(state) {
      return state.paShadowingHours
    },
    // Total PA Shadowing Hours
    totalPaShadowingHours(state) {
      var sum = 0
      for(var i=0; i < state.paShadowingHours.length; i++) {
        for(var s=0; s < state.paShadowingHours[i].logged_hours.length; s++) {
         sum += parseFloat(state.paShadowingHours[i].logged_hours[s].shadowing_hours)
        }
      }
      return sum
    },
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/pashadowing.js